/**
 * Conceptual Views Architecture Types
 * Exactly 3 views: Operations Hub, Resident Portal, Contractor Cockpit
 */

export type ViewType = "operations" | "resident" | "contractor";
export type ConceptualView = ViewType;

export const VIEW_TYPES: readonly ViewType[] = Object.freeze([
  "operations",
  "resident",
  "contractor",
] as const);

export interface ViewDefinition {
  id: ViewType;
  label: string;
  description: string;
  defaultRoute: string;
  requiredContext: "organization" | "personal";
}

export const VIEW_DEFINITIONS: Record<ViewType, ViewDefinition> = {
  operations: {
    id: "operations",
    label: "Operations Hub",
    description: "Property management, leasing, financials, operations triage",
    defaultRoute: "/",
    requiredContext: "organization",
  },
  resident: {
    id: "resident",
    label: "Resident Portal",
    description: "Lease review, rent payments, maintenance requests",
    defaultRoute: "/tenant/lease",
    requiredContext: "personal",
  },
  contractor: {
    id: "contractor",
    label: "Contractor Cockpit",
    description: "Daily field roadmap, itinerary, work orders, payment statements",
    defaultRoute: "/vendor/cockpit",
    requiredContext: "organization",
  },
};
